import { Link } from "react-router-dom";
import type { WorkItem } from "@/mocks/works";

export default function WorkCard({ item }: { item: WorkItem }) {
  return (
    <Link
      to={`/recommend/${item.id}`}
      className="group relative block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-64 w-full overflow-hidden">
        <img
          src={item.cover}
          alt={`${item.title} - 91动漫作品推荐`}
          title={`${item.title} - 91动漫`}
          className="h-full w-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 flex translate-y-2 flex-col bg-gradient-to-t from-secondary-950/95 via-secondary-950/70 to-transparent p-4 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
          <p className="line-clamp-3 text-xs leading-relaxed text-white/90">{item.synopsis}</p>
          <span className="mt-2 flex items-center gap-2 text-xs text-accent-300">
            <i className="ri-play-circle-line text-sm" />
            查看详情与观看指南
          </span>
        </div>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-primary-500 px-2 py-1 text-xs font-bold text-white">
          <i className="ri-star-fill text-xs" />
          {item.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="line-clamp-1 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          <span className="rounded-full bg-secondary-100 px-2 py-0.5 font-medium text-secondary-800">
            {item.category}
          </span>
          <span>{item.region}</span>
          <span className="text-foreground-300">·</span>
          <span>{item.year}</span>
        </div>
      </div>
    </Link>
  );
}